import FileButton from 'common/components/buttons/FileButton';
import FileSyncTooltip from '@/library/components/form/inputs/upload-files/FileSyncTooltip';
import useTooltipID from 'common/utils/hooks/useTooltipID';
import SvgRender from 'common/components/general/SvgRender';

import { isFileSynced } from '@/api/files/api';
import { FC } from 'react';
import { Attachment } from '@/library/types/files';
import { DownloadAttachmentSizeType } from './config';

type AttachmentFileProps = {
  onClick: (e: React.MouseEvent<HTMLElement>, file: Attachment) => void;
  size?: DownloadAttachmentSizeType;
  file: Attachment;
  icon: string;
  index: number;
  className?: string;
};

const AttachmentFile: FC<AttachmentFileProps> = ({
  onClick,
  size,
  file,
  icon,
  index,
  className
}) => {
  const { tooltipID, avoidRender } = useTooltipID(`download-attachment-file`);
  const { is_synced } = isFileSynced(file);

  if (avoidRender) return null;

  return (
    <>
      <FileButton
        key={file.id}
        className={`cme-4 ${className}`}
        onClick={(e: React.MouseEvent<HTMLElement>) => (is_synced ? onClick(e, file) : null)}
        id={tooltipID}
        size={size}
        dataCy={`file-button-${index + 1}`}
      >
        <SvgRender src={icon} className="p-1" />
      </FileButton>

      <FileSyncTooltip file={file} tooltipID={tooltipID} />
    </>
  );
};
export default AttachmentFile;
